export const FRESHTEAMS_ACTIVATION_STATUS_QUERY = 'freshteamsActivationStatus';
